/**
 * Mobile Menu Module
 * Handles mobile navigation toggle, overlay, and escape key
 */

export function initMobileMenu() {
  const toggleBtn = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.getElementById('mobile-menu');
  const overlay = document.querySelector('[data-mobile-menu-overlay]');
  const header = document.querySelector('.header');
  const closeLinks = document.querySelectorAll('[data-mobile-menu-close]');

  if (!toggleBtn || !menu) return;

  let isOpen = false;

  function openMenu() {
    isOpen = true;
    menu.classList.add('mobile-menu--open');
    menu.setAttribute('aria-hidden', 'false');
    toggleBtn.setAttribute('aria-expanded', 'true');
    header?.classList.add('header--menu-open');
    overlay?.style.setProperty('display', 'block');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    isOpen = false;
    menu.classList.remove('mobile-menu--open');
    menu.setAttribute('aria-hidden', 'true');
    toggleBtn.setAttribute('aria-expanded', 'false');
    header?.classList.remove('header--menu-open');
    overlay?.style.setProperty('display', 'none');
    document.body.style.overflow = '';
  }

  function toggleMenu() {
    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  // Toggle button click
  toggleBtn.addEventListener('click', toggleMenu);

  // Overlay click to close
  overlay?.addEventListener('click', closeMenu);

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && isOpen) {
      closeMenu();
      toggleBtn.focus();
    }
  });

  // Close when clicking nav links
  closeLinks.forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  // Close on resize to desktop
  window.addEventListener('resize', () => {
    if (window.innerWidth >= 1024 && isOpen) {
      closeMenu();
    }
  });
}
